export const inspectionTabs = [
  { id: 'schedules', label: 'Maintenance schedules' },
  { id: 'items', label: 'Inspection items' },
  { id: 'coverage', label: 'Coverage & gaps' }
]

export function readInspectionView (params) {
  const requested = params.get('inspectionView')
  if (inspectionTabs.some(tab => tab.id === requested)) return requested
  const legacy = params.get('tab')
  const legacyViews = new Map([
    ['0', 'schedules'],
    ['1', 'items'],
    ['2', 'coverage'],
    ['schedules', 'schedules'],
    ['items', 'items'],
    ['coverage', 'coverage']
  ])
  return legacyViews.get(legacy) || 'schedules'
}

export function inspectionScopeKey (companyId, siteId, assetId) {
  return JSON.stringify([
    String(companyId ?? ''),
    String(siteId ?? ''),
    String(assetId ?? '')
  ])
}

export function readInspectionSelection (params, scopeKey) {
  // A campaign selected at a different location must not silently scope this view.
  if (params.get('inspectionScope') !== scopeKey)
    return { campaignId: null, itemId: null }
  return {
    campaignId: params.get('inspectionCampaign') || null,
    itemId: params.get('inspectionItem') || null
  }
}

export function changeInspectionView (previous, view) {
  const next = new URLSearchParams(previous)
  next.set(
    'inspectionView',
    inspectionTabs.some(tab => tab.id === view) ? view : 'schedules'
  )
  next.delete('tab')
  return next
}

// Reserved for real campaign/item selection once those read contracts exist.
export function changeInspectionSelection (
  previous,
  scopeKey,
  { campaignId = null, itemId = null, view = 'items' } = {}
) {
  const next = changeInspectionView(previous, view)
  for (const [key, value] of [
    ['inspectionCampaign', campaignId],
    ['inspectionItem', itemId]
  ]) {
    if (value === null || value === undefined || value === '') next.delete(key)
    else next.set(key, String(value))
  }
  if (next.has('inspectionCampaign') || next.has('inspectionItem'))
    next.set('inspectionScope', scopeKey)
  else next.delete('inspectionScope')
  return next
}
